import { render, staticRenderFns } from "./Step3SaveTemplateModal.vue?vue&type=template&id=2f9dc0d3&scoped=true"
import script from "./Step3SaveTemplateModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./Step3SaveTemplateModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Step3SaveTemplateModal.vue?vue&type=style&index=0&id=2f9dc0d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9dc0d3",
  null
  
)

export default component.exports